import { DolfinParser } from './base'

export class IntToFloatParser extends DolfinParser {
  execute(formula: string): string {
    const replacedTags = this.getTags(formula).map(tag =>
      this.convertIntToFloat(tag)
    )

    return replacedTags.join(' ')
  }

  private convertIntToFloat(s: string): string {
    return s.replace(/^-?(\d+\.\d+)|\d+$/g, function(match) {
      return match.indexOf('.') !== -1 ? match : match + '.0'
    })
  }
}
